/* eslint-disable react/prop-types */
import React from 'react';
import { Spinner } from 'reactstrap';

import { Button, Modal } from 'rsuite';

function DeleteModal({ toggle, modal, handleDelete, id, loading }) {
  return (
    <Modal show={modal} onHide={toggle} style={{ overflowY: 'hidden' }}>
      <Modal.Header toggle={toggle}>
        Você tem certeza que deseja excluir ?
      </Modal.Header>
      {loading ? (
        <Modal.Footer>
          <Button color="danger">
            <Spinner size="sm" color="dark" />
          </Button>
          <Button color="primary">
            <Spinner size="sm" color="dark" />
          </Button>
        </Modal.Footer>
      ) : (
        <Modal.Footer>
          <Button color="danger" onClick={toggle}>
            Não
          </Button>
          <Button
            color="primary"
            onClick={() => {
              handleDelete(id);
              toggle();
            }}
          >
            Sim
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default DeleteModal;
